import { useSearchContext } from '../../../../context/PlpContext';

export const useAppliedFiltersData = () => {
  const { filter } = useSearchContext();

  return {
    filter,
  };
};
